import { dailySessionNotes } from '../../actions/constant';

const {
  PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_FAILURE,
  PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_SUCCESS,
  RESET_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION,
  SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_LOADING,
} = dailySessionNotes;

const intitialstate: object = {
  response: null,
  loading: false,
  isNoteUpdated: false,
};

export const updateSoapNoteReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_SUCCESS: {
      return {
        ...state,
        isNoteUpdated: true,
        response: action.payload,
        loading: false,
      };
    }

    case PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_FAILURE:
      return {
        ...state,
        isNoteUpdated: false,
        response: action.payload,
        loading: false,
      };

    case SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_LOADING:
      return {
        ...state,
        loading: true,
      };

    case RESET_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION:
      return intitialstate;

    default:
      return state;
  }
};
